module.exports = "/fonts/FiraSans-ThinItalic.ttf";